import React from 'react';
import '../template-file-css/document-file-template.css';



export const LaGeneral_BehaviorModificationPlan = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LaGeneral_BehaviorModificationPlan' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'>
                    <span className='eleHeader'>Specific Behavior that needs modifying </span>
                    <span className='small'>(chose one very specific behavior; i.e. I don't eat vegetables is more specific than I don't eat healthy)</span>
                    <textarea id='txtSpecificBx' name='txtSpecificBx' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Client's (and Parents') reason for wanting to change this behavior</span>
                    <textarea id='txtClientReason' name='txtClientReason' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>What specific, achievable steps will be taken by client (and parents) to address specific behavior</span>
                    <span className='small'>(i.e. I will eat a half-cup of vegetables with lunch and dinner)</span>
                    <textarea id='txtSteps' name='txtSteps' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>What is the negative consequence(s) if the client does not take the steps to address the behavior</span>
                    <textarea id='txtNegativeConsequence' name='txtNegativeConsequence' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>What is the positive consequence(s) if the client does take the steps to address the behavior</span>
                    <textarea id='txtPositiveConsequence' name='txtPositiveConsequence' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Who is involved in this plan and will help administer negative/positive consequences</span>
                    <textarea id='txtInvolved' name='txtInvolved' className='add-only'></textarea>
                </p>


            </div>
        </form >

    )
}











